import React, { useEffect, useState } from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Alert } from "reactstrap";
import ContainerApAbierto from "./ContainerApAbierto";
import Formulario from "../Generales/Formulario";
import { ambienteAplicacion, urlCiudadesAP, urlConsultarDuplicidad, urlConsultarIdentificacion, urlProcesoApAbierto, urlRecuperarCarritoAccP, urlSucursales } from "../../constants/urls";
import { useSelector } from "react-redux";
import { apiPost2 } from "../../api";
import { empresa, EquiRamos, ErrorMsgConstants } from "../../constants";
import moment from "moment";


const ComponentApAbiertoDatosCliente = (props) => {





    const [loading, setLoading] = useState(false)
    const [values, setValues] = useState({})
    const [idCarrito, setIdCarrito] = useState(null)
    const [existeCarrito, setExisteCarrito] = useState(false)
    const [duplicada, setDuplicada] = useState(false)
    const [ciudadesAux, setCiudadesAux] = useState([])


    useEffect(() => {
        console.log('cotizador', props)
        window.scrollTo(0, 0);
    }, [])




    const datosAsesor = useSelector((state) => state.datosUsuarios.dataUsuario)
    const listadoSucursales = useSelector((state) => state.datosSucursales.DataSucursales || [])




    const resolverSucursal = async (sucursal) => {
        if (!sucursal) return ""

        const codigo = typeof sucursal === 'object' ? sucursal.value : sucursal

        let sucursales = listadoSucursales
        if (!sucursales.length) {
            try {
                const response = await fetch(urlSucursales)
                const json = await response.json()
                sucursales = json.transaccion ? json.sucursales : []
            } catch (error) {
                sucursales = []
            }
        }

        const encontrada = sucursales.find(s => String(s.sucCodigoCore) === String(codigo))
        if (encontrada) {
            return { value: encontrada.sucCodigoCore, label: encontrada.sucNombre }
        }
        if (datosAsesor && String(datosAsesor.sucursalCodCore) === String(codigo)) {
            return { value: datosAsesor.sucursalCodCore, label: datosAsesor.sucursal }
        }
        if (typeof sucursal === 'object' && sucursal.label && String(sucursal.label) !== String(codigo)) return sucursal
        return { value: codigo, label: codigo }
    }

    /**
     * recupera la información del carrito
     */
    const recuperarCarrito = async (values) => {

        setLoading(true)
        const queryParams = new URLSearchParams(props.location.search);
        const idCarritoParam = queryParams.get("id");

        if (idCarritoParam) {
            const resultado = await apiPost2(urlRecuperarCarritoAccP, {
                empresa: empresa,
                idCarrito: idCarritoParam
            })

            if (resultado.transaccion) {

                setExisteCarrito(true)
                setIdCarrito(idCarritoParam)

                consultarProvincia(resultado.datosUbicacion.provincia.value)
                let objeto = values

                objeto.cedulaSolicitante = resultado.datosContratantePersona.cliIdentificacion
                objeto.ruc = resultado.datosContratanteEmpresa.cliIdentificacion
                objeto.nombreEmpresa = resultado.datosContratanteEmpresa.cliRazonSocial
                objeto.actividadEmpresa = resultado.datosContratanteEmpresa.actividad
                objeto.nombreSolicitante = resultado.datosContratantePersona.nombreCompleto
                objeto.provincia = resultado.datosUbicacion.provincia
                objeto.ciudad = resultado.datosUbicacion.ciudad
                objeto.direccion = resultado.datosUbicacion.direccion
                objeto.sucursal = await resolverSucursal(resultado.sucursal)
                objeto.numeroDias = resultado.facturacion.numeroDias
                objeto.lugarEvento = resultado.lugarEvento
                objeto.siniestralidad = resultado.siniestralidad

                let fecha = null

                if (resultado.fechaVigencia) {

                    fecha = {
                        "startDate": new Date(resultado.fechaVigencia.startDate),
                        "endDate": new Date(resultado.fechaVigencia.endDate),

                    }
                    objeto.fechaVigencia = fecha

                }




                setValues(objeto)


            }


        }
        setLoading(false)


    }

    const guardarInformacion = async (values) => {
        window.scrollTo(0, 0);

        setLoading(true)



        values.facturacion['numeroDias'] = values.numeroDias

        if (values.fechaVigencia) {


            const daysDifference = moment(values.fechaVigencia.endDate).diff(moment(values.fechaVigencia.startDate), 'days');

            values.facturacion['numeroDias'] = daysDifference == 0 ? 1 : daysDifference + 1

        }

        console.log('facturacion2', ciudadesAux, values.ciudad.value, ciudadesAux.find(ciudad => ciudad.value == values.ciudad.value))


        let url = `${urlProcesoApAbierto}`;
        const body = {
            "empresa": "AIGMETROPOLITANA",
            "plataforma": "WEB",
            "ambiente": "Desarrollo",
            "descripcionSeguro": props.datosCotizador.descripcionSeguro,
            "sucursal": values.sucursal,
            "empresaNombre": values.nombreEmpresa.trim(),
            "empresaRuc": values.ruc.trim(),
            "solicitanteNombre": values.nombreSolicitante.trim(),
            "solicitanteCedula": values.cedulaSolicitante.trim(),
            "idAsesor": datosAsesor.cliCodigoCore,
            "pasoCarrito": "inicio",
            "provincia": values.provincia,
            "facturacion": values.facturacion,
            "siniestralidad": values.siniestralidad,
            "ciudad": ciudadesAux.find(ciudad => ciudad.value == values.ciudad.value),
            "idCarrito": existeCarrito ? idCarrito : "",
            "direccion": values.direccion.trim(),
            "lugarEvento": values.lugarEvento,
            "fechaVigencia": values.fechaVigencia,
            "numeroPersonas": 5,
            "objetoAsesor": {
                nombre: `${datosAsesor.nombres} ${datosAsesor.apellidos}`,
                codigoCore: datosAsesor.cliCodigoCore,
                sucursalSeleccionada: values.sucursal.value,
                ambiente: ambienteAplicacion,
                emailAsesor: datosAsesor.correo ? datosAsesor.correo : '',
                brokerRUC: datosAsesor.brokerRUC ? datosAsesor.brokerRUC : '',
                brokerNombre: datosAsesor.brokerNombre ? datosAsesor.brokerNombre : '',
                brokerCodigo: datosAsesor.brokerCodigo ? datosAsesor.brokerCodigo : '',
            },
            "actividad": values.actividadEmpresa
        }
        try {
            const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
            const json = await response.json()
            if (json.transaccion) {
                props.history.push({
                    pathname: props.datosCotizador.urlSiguiente,
                    search: `?id=${json.idCarrito}`, //agregar parametros de la url,
                });
            }


            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const consultarRuc = async (ruc, values, tipo, campoModifica, campoBuscador) => {

        setLoading(true)


        const resultado = await apiPost2(urlConsultarIdentificacion, {
            "empresa": empresa,
            "identificador": ruc,
            "tipo": tipo
        })



        if (resultado.transaccion) {
            let objeto = { ...values }
            objeto[campoModifica] = resultado.datosIdentificador[0][campoBuscador];
            setValues(objeto)
        }



        setLoading(false)
    }

    const consultarProvincia = async (provincia) => {

        setLoading(true)


        const resultado = await apiPost2(urlCiudadesAP, {
            empresa: "AIGMETROPOLITANA",
            codProvincia: provincia,
            ramo: "travel"
        })


        if (resultado.transaccion) {
            setCiudadesAux(resultado.ciudades)
        }



        setLoading(false)
    }

    return (
        <ContainerApAbierto
            paso={'cotizacion'}
            titulo={props.datosCotizador.titulo}
        >

            <main class="cr-app bg-light">
                <div class="cr-content container-fluid">
                    <div className="container-body-spaces">

                        <LoadingScreen
                            loading={
                                loading
                            }

                            bgColor="#f1f1f1"
                            spinnerColor="#001871"
                            textColor="#676767"
                            logoSrc={logo}
                            text="Obteniendo datos..."
                        >

                            <Formulario
                                codigoFormulario={props.datosCotizador.codigoFormulario}
                                setLoading={(value) => setLoading(value)}
                                onSubmit={async (values, tieneErrores, errores) => {

                            

                                    if (!tieneErrores && (values.siniestralidad && values.siniestralidad == 'NO'))  {
                                        const checkDuplicidadObj = {
                                            empresa: "AIGMETROPOLITANA",
                                            plataforma: 'WEB',
                                            identificacion: values.ruc,
                                            ramo: EquiRamos.ap,
                                        };

                                        if (existeCarrito) {
                                            guardarInformacion(values)
                                        } else {

                                            const url = urlConsultarDuplicidad

                                            const response = await fetch(url, { body: JSON.stringify(checkDuplicidadObj), method: 'POST' })
                                            const json = await response.json()



                                            if (json.tienePolizaVigente) {
                                                setDuplicada(true)
                                            } else {
                                                guardarInformacion(values)
                                                setDuplicada(false)

                                            }





                                        }





                                    }
                                }}
                                values={values}

                                onChange={(key, values) => {

                                    setValues(values)


                                    if (key == 'provincia') {
                                        consultarProvincia(values.provincia.value)
                                    }

                                    if (key == 'ruc') {
                                        if (values.ruc && values.ruc.length == 13) {
                                            consultarRuc(values.ruc, values, 'ruc', 'nombreEmpresa', 'nombre')
                                        }
                                    }

                                    if (key == 'cedulaSolicitante') {
                                        if (values.cedulaSolicitante && values.cedulaSolicitante.length == 10) {
                                            consultarRuc(values.cedulaSolicitante, values, 'cedula', 'nombreSolicitante', 'nombre')
                                        }
                                    }


                                }}

                                setValuesInicial={(values) => {

                                    recuperarCarrito(values)





                                }}
                            />

                            {duplicada
                                ?
                                <Alert color="danger">
                                    <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                                </Alert>
                                :
                                null
                            }




                        </LoadingScreen>



                    </div>
                </div>
            </main>

        </ContainerApAbierto>

    );
};

export default ComponentApAbiertoDatosCliente;
